import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementRotaDeleteResponse } from "@/api_framework/api_modals/Rota";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useRotaDeleteAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (shiftId: string) => {
      // dispatch(
      //   setLoading({
      //     key: "isOrgServicesInProgress",
      //     status: true,
      //   })
      // );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .delete(ROTA_APIS?.ROTA_DELETE_API?.baseURL ?? "", {
            params: { id: shiftId },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IRotaManagementRotaDeleteResponse>) => {
            if (res.data.status === true) {
              toast.success("Schedule Successfully Deleted");
              dispatch(
                setLoading({
                  key: "isOrgServicesInProgress",
                  status: false,
                }),
              );
            } else {
              //
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e)
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
